import { ExtraDriverField } from '../../components/forms/types';
import { DriverDetailsFormItem } from '../../components/manage-drivers/types';
import { isEmployed, isNotEmpty } from './utils';

export type DriverShortFormValues = {
	employmentType: string;
	occupation: string;
	industry: string;
	otherOccupation: string;
	otherIndustry: string;
	otherEmployment: string;
	driverUsage?: string;
	employmentStatus: string;
	otherEmploymentType: string;
	otherEmploymentStatus: string;
};

export const getDriverShortFormValues = (
	driver: DriverDetailsFormItem,
	extraFields: ExtraDriverField[],
): DriverShortFormValues => {
	const initialValues: DriverShortFormValues = {
		employmentType: driver?.employmentType || '',
		occupation: driver?.occupation || '',
		industry: driver?.industry || '',
		otherOccupation: driver?.otherOccupation || '',
		otherIndustry: driver?.otherIndustry || '',
		otherEmployment:
			(driver && isNotEmpty(driver.otherOccupation) && isNotEmpty(driver.otherIndustry)) ||
			(isNotEmpty(driver.otherEmploymentType) && isNotEmpty(driver.otherEmploymentStatus))
				? 'yes'
				: 'no',
		employmentStatus: isEmployed(driver.employmentStatus),
		otherEmploymentType: driver.otherEmploymentType || '',
		otherEmploymentStatus: isEmployed(driver.otherEmploymentStatus),
	};

	if (extraFields.includes('driverUsage')) {
		initialValues.driverUsage = driver?.driverUsage || '';
	}

	return initialValues;
};
